export default "__VITE_ASSET__BYvhsNcL__"